import { render, staticRenderFns } from "./UploadPOC.vue?vue&type=template&id=180ff444&"
import script from "./UploadPOC.vue?vue&type=script&lang=js&"
export * from "./UploadPOC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports